import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarFile, F0Button } from '@factorialco/f0-react'
import { Delete } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

interface FileItemProps {
  fileWithId: {
    id: string
    file: File
  }
  onDelete: (fileId: string) => void
}

export const FileItem = ({ fileWithId, onDelete }: FileItemProps) => {
  const { id, file } = fileWithId

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      gap="s12"
      justifyContent="spaceBetween"
      padding="s12"
    >
      <Box flexDirection="row" alignItems="center" gap="s12" overflowX="hidden">
        <F0AvatarFile
          file={{
            name: file.name,
            type: file.type,
          }}
          size="md"
        />
        <Text.Normal size="300" color="grey1000" ellipsis weight="medium">
          {file.name}
        </Text.Normal>
      </Box>
      <F0Button
        variant="outline"
        onClick={() => onDelete(id)}
        icon={Delete}
        label={i18n.t('common.delete')}
        hideLabel
      />
    </Box>
  )
}
